<template>
  <v-row>
    <v-col xs="12" sx="12" md="12" xl="12">
      <v-card flat :loading="loading">
        <v-card-title>
          Elenco immagini per il totem
          <v-btn icon class="ml-3">
            <v-icon @click="refresh">mdi-refresh</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <file-dir-list :alberaturaAssets="alberatura" :codiceTotem="codiceTotem" :trigger="triggerUpdate" @change="onChangeFile"/>     
        </v-card-text>    
      </v-card>
      <v-card-actions>
        <v-btn title="Sincronizza la cartella prodotti con l'elenco delle relative immagini" @click="onSincronizzaProdotti">Sincronizza prodotti</v-btn>
        <v-spacer></v-spacer>
        <v-btn title="Invia tutte le immagini al totem" color="warning" @click="onPrimaInstallazione">Prima installazione</v-btn>
      </v-card-actions>
    </v-col>
  </v-row>
</template>

<script>
  import FileDirList from './fileDirList'

  export default {
    components: {
      FileDirList
    },
    props: {
      codiceTotem: String,
      alberaturaAssets: Object,
      triggerUpdate: Number
    },    
    data () {
      return {
        elencoFile: '',
        loading: false,
        files: [],
        filesInFolder: [],
        defaultDati: {
          codice: '',
          titolo: '',
          note: '',
          categoria: 'Generale',
          gruppo: 'Cassa',
          posizione: '',
          default: true,
          daPersonalizzare: true,
          tag: 'tutti',
          payload: {
          },
          meta: {
          }
        },
        defaultMd:'##',
        elencoIds: []
      }
    },
    computed: {
      alberatura() {
        return this.alberaturaAssets
      }
    },
    methods: {
      onClearFile() {
        this.elencoFile = ''
      },
      onChangeFile(payload) {
        this.$emit('change', payload)
      },
      refresh() {
        this.$emit('refresh')
      },
      async onSincronizzaProdotti() {
        console.log(this.codiceTotem)
        this.$emit('sincronizza', this.codiceTotem)
      },
      async onPrimaInstallazione() {
        this.$emit('prima-installazione', this.codiceTotem)
      }      
    }
  }
</script>
